<!-- Custom case for isArrayOfRefs: handle nested arrays of objects like [[obj,obj],...] -->
<ng-container *ngIf="field.options?.isArrayOfRefs; else standardNestedList">
    <strong>{{ camelCaseToWords(field.label) }}:</strong>
    <div *ngFor="let nestedArray of getNestedValue(record, field.key); let i = index" class="nested-array-group">
        <h5>Group {{ i + 1 }}:</h5>
        <ul>
            <li *ngFor="let item of nestedArray">
                <span>{{ item.name || item.identifier }}</span>
                <a *ngIf="item.id && field.controller" 
                   [href]="'/' + field.controller + '/' + item.id" 
                   style="color: var(--primary-color)">
                    ({{ item.id }})
                </a>
                <span *ngIf="item.id && !field.controller">({{ item.id }})</span>
            </li>
        </ul>
    </div>
</ng-container>

<!-- Standard NestedList behavior -->
<ng-template #standardNestedList>
    <ng-container *ngFor="let nestedKey of getNestedValue(record, field.key)">
        <ng-container *ngIf="isObject(nestedKey)">
            <strong>{{ camelCaseToWords(field.label) }}:</strong>
            <ul>
                <li>
                    <app-dynamic-list [record]="nestedKey"></app-dynamic-list>
                </li>
            </ul>
        </ng-container>
        <ng-container *ngIf="isArray(nestedKey)">
            <strong>{{ camelCaseToWords(field.label) }}:</strong>
            <ul>
                <ng-container *ngFor="let item of nestedKey">
                    <li *ngIf="isObject(item)">
                        <app-dynamic-list [record]="item"></app-dynamic-list>
                    </li>
                    <li *ngIf="!isObject(item)">
                        {{ item }}
                    </li>
                </ng-container>
            </ul>
        </ng-container>
        <ng-container *ngIf="!isObject(nestedKey) && !isArray(nestedKey)">
            <strong>{{ camelCaseToWords(field.label) }}:</strong> {{ nestedKey }}
        </ng-container>
    </ng-container>
</ng-template>